module.exports = __webpack_public_path__ + "img/image_title.6339ab16.png";